var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseForm',{attrs:{"panels":_vm.panels,"action":_vm.createAction,"formClass":_vm.formClass,"errorMessage":_vm.errorMessage,"method":_vm.method,"baseMethod":_vm.baseMethod,"moduleName":_vm.moduleName,"list-link":_vm.listLink}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43b32eaa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/custom/CustomCreateModule.vue
// module id = null
// module chunks = 